// Form field DOM id helpers.
//
// Field names can be human labels (e.g. custom field labels with spaces),
// which are not valid as id / aria-describedby tokens — a space inside an
// id silently breaks the token reference. Every id derived from a field
// name must go through fieldDomId so the help-description id, the error id,
// and the aria-describedby that points at them stay in agreement.

export const fieldDomId = (fieldName: string) => fieldName.replace(/\s+/g, '-');

export const fieldHelpDescriptionId = (fieldName: string) => (
  `${fieldDomId(fieldName)}-description`
);

export const fieldErrorId = (fieldName: string) => `${fieldDomId(fieldName)}-error`;

interface DescribedByParts {
  fieldName: string;
  hasError: boolean;
  hasHelp: boolean;
}

// Builds the aria-describedby token list a field control points at: its
// on-demand help description (when help text is present) and its error
// message (when invalid). Returns undefined when neither applies so the
// attribute is omitted rather than rendered empty.
export const fieldDescribedBy = ({
  fieldName,
  hasError,
  hasHelp,
}: DescribedByParts) => (
  [
    hasHelp ? fieldHelpDescriptionId(fieldName) : '',
    hasError ? fieldErrorId(fieldName) : '',
  ].filter(Boolean).join(' ') || undefined
);
